import { ActionType, createAsyncAction } from 'typesafe-actions';
import { FetchAction, DefaultErrorPayload } from './generators';

export interface DataFetchingRequest extends FetchAction {
    requestIssuer: string;
}

export const dataFetchActions = createAsyncAction(
    '@DataFetching/FETCH_START',
    '@DataFetching/FETCH_SUCCESS',
    '@DataFetching/FETCH_FAILED'
)<DataFetchingRequest, DataFetchingRequest, DataFetchingRequest & DefaultErrorPayload>();

export type DataFetchActionsType = ActionType<typeof dataFetchActions>;
